import { render, staticRenderFns } from "./createManageCodes.vue?vue&type=template&id=18d10977"
import script from "./createManageCodes.vue?vue&type=script&lang=js"
export * from "./createManageCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports